document.addEventListener('DOMContentLoaded', function () {
  if (document.documentElement.getAttribute('dir') !== 'rtl') return;

  function fixSliderRTL(slider) {
    // نتأكد إن السلايدر يبدأ من أول عنصر (يمين) في وضع RTL
    requestAnimationFrame(function () {
      slider.scrollLeft = slider.scrollWidth - slider.clientWidth;
    });
  }

  // كل العناصر اللي عاملة سلايدر (الكوليكشن، المنتجات، إلخ)
  var sliders = document.querySelectorAll('slider-component ul.slider, .slider');

  sliders.forEach(function (slider) {
    fixSliderRTL(slider);

    // لو فيه إعادة تحميل ديناميكي (Ajax cart, sections re-render)
    var observer = new MutationObserver(function () {
      fixSliderRTL(slider);
    });
    observer.observe(slider, { childList: true });
  });
});